import { BUOfUserEntity } from '@/domain/entities/users';
import { UsersRepository } from '@/domain/ports/users/repositories';

export class GetBuOfCurrentUserUsecase {
  constructor(private readonly repository: UsersRepository) {}

  async run(id: string): Promise<BUOfUserEntity> {
    const user = await this.repository.getBuOfCurrentUser(id);

    return user;
  }
}
